module.exports = __webpack_public_path__ + "img/left03.f8165fb7.webp";